function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, CopyButton, LoadingSpinner } from '@deephaven/components';
import { dhFreeze, dhRefresh, dhSortSlash, vsLock } from '@deephaven/icons';
import Log from '@deephaven/log';
import { PromiseUtils } from '@deephaven/utils';
import { isEditableGridModel, isExpandableGridModel } from '@deephaven/grid';
import "./ColumnStatistics.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var log = Log.module('ColumnStatistics');
var STATS_LABEL_OVERRIDES = {
  SIZE: 'Number of Rows'
};
class ColumnStatistics extends Component {
  static getStatsLabel(operation) {
    var _STATS_LABEL_OVERRIDE;
    return (_STATS_LABEL_OVERRIDE = STATS_LABEL_OVERRIDES[operation]) !== null && _STATS_LABEL_OVERRIDE !== void 0 ? _STATS_LABEL_OVERRIDE : operation.split(' ').map(w => w[0].toUpperCase() + w.substr(1).toLowerCase()).join(' ');
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "cancelablePromise", void 0);
    this.handleError = this.handleError.bind(this);
    this.handleGenerateStatistics = this.handleGenerateStatistics.bind(this);
    this.handleStatistics = this.handleStatistics.bind(this);
    this.cancelablePromise = null;
    this.state = {
      error: null,
      loading: false,
      statistics: null,
      numRows: 0
    };
  }
  componentDidMount() {
    this.maybeGenerateStatistics();
  }
  componentWillUnmount() {
    if (this.cancelablePromise) {
      this.cancelablePromise.cancel();
    }
  }
  maybeGenerateStatistics() {
    var _this$props = this.props,
      column = _this$props.column,
      model = _this$props.model;
    var numRows = model.rowCount - model.pendingRowCount - model.floatingBottomRowCount - model.floatingTopRowCount;
    this.setState({
      numRows
    });
    if (!model.isColumnStatisticsAvailable || column.isProxy === true) {
      this.setState({
        loading: false
      });
    } else if (numRows < ColumnStatistics.AUTO_GENERATE_LIMIT) {
      this.handleGenerateStatistics();
    }
  }
  handleGenerateStatistics() {
    this.setState({
      loading: true
    });
    var _this$props2 = this.props,
      column = _this$props2.column,
      model = _this$props2.model;
    this.cancelablePromise = PromiseUtils.makeCancelable(model.columnStatistics(column));
    this.cancelablePromise.then(this.handleStatistics).catch(this.handleError);
  }
  handleStatistics(stats) {
    log.debug('Received statistics', stats);
    var _this$props3 = this.props,
      model = _this$props3.model,
      onStatistics = _this$props3.onStatistics;
    var statistics = [];
    stats.statisticsMap.forEach((value, operation) => {
      statistics.push({
        operation: ColumnStatistics.getStatsLabel(operation),
        value,
        type: stats.getType(operation)
      });
    });
    stats.uniqueValues.forEach((value, operation) => {
      statistics.push({
        operation,
        className: 'column-statistics-unique-value',
        value,
        type: 'long'
      });
    });
    this.setState({
      loading: false,
      statistics,
      numRows: model.rowCount - model.pendingRowCount - model.floatingBottomRowCount - model.floatingTopRowCount
    });
    onStatistics();
  }
  handleError(error) {
    if (error != null && PromiseUtils.isCanceled(error)) {
      log.debug('Called handleError on a cancelled promise result');
      return;
    }
    log.error('Error generating statistics', error);
    this.setState({
      error,
      loading: false,
      statistics: null
    });
  }
  render() {
    var _column$displayName;
    var _this$props4 = this.props,
      column = _this$props4.column,
      model = _this$props4.model;
    var _this$state = this.state,
      error = _this$state.error,
      loading = _this$state.loading,
      statistics = _this$state.statistics,
      numRows = _this$state.numRows;
    var showGenerateStatistics = !loading && error == null && statistics == null && model.isColumnStatisticsAvailable;
    var statisticElements = [];
    var columnType = column.type.substring(column.type.lastIndexOf('.') + 1);
    var description = column.description === null ? null : column.description;
    if (statistics != null) {
      for (var i = 0; i < statistics.length; i += 1) {
        var _statistics$i = statistics[i],
          operation = _statistics$i.operation,
          className = _statistics$i.className,
          value = _statistics$i.value,
          type = _statistics$i.type;
        var formattedValue = !type ? model.displayString(value, column.type, column.name) : model.displayString(value, type);
        var statisticElement = /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: classNames('column-statistic-operation', className),
            children: operation
          }), /*#__PURE__*/_jsx("div", {
            className: "column-statistic-value",
            children: formattedValue
          })]
        }, operation);
        statisticElements.push(statisticElement);
      }
    }
    var rowCountLabel = isExpandableGridModel(model) && model.hasExpandableRows ? 'Expanded Rows' : 'Number of Rows';
    var formattedRowCount = model.displayString(numRows, 'long');
    var columnIndex = model.getColumnIndexByName(column.name);
    return /*#__PURE__*/_jsxs("div", {
      className: "column-statistics",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "column-statistics-title",
        children: [(_column$displayName = column.displayName) !== null && _column$displayName !== void 0 ? _column$displayName : column.name, /*#__PURE__*/_jsxs("span", {
          className: "column-statistics-type",
          children: ["\xA0(", columnType, ")"]
        }), /*#__PURE__*/_jsx(CopyButton, {
          tooltip: "Copy column name",
          copy: column.name,
          isQuiet: true
        })]
      }), description != null && /*#__PURE__*/_jsx("div", {
        className: "column-statistics-description",
        children: description
      }), columnIndex != null && !model.isColumnSortable(columnIndex) && /*#__PURE__*/_jsxs("div", {
        className: "column-statistics-status",
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: dhSortSlash,
          className: "mr-1"
        }), "Not sortable"]
      }), columnIndex != null && !model.isColumnMovable(columnIndex) && /*#__PURE__*/_jsxs("div", {
        className: "column-statistics-status",
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: model.isColumnFrozen(columnIndex) ? dhFreeze : vsLock,
          className: "mr-1"
        }), model.isColumnFrozen(columnIndex) ? 'Frozen' : 'Not movable']
      }), columnIndex != null && isEditableGridModel(model) && model.isEditable && !model.keyColumnSet.has(column.name) && !model.valueColumnSet.has(column.name) && /*#__PURE__*/_jsxs("div", {
        className: "column-statistics-status",
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: vsLock,
          className: "mr-1"
        }), "Not editable"]
      }), /*#__PURE__*/_jsxs("div", {
        className: "column-statistics-grid",
        children: [statistics == null && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "column-statistic-operation",
            children: rowCountLabel
          }), /*#__PURE__*/_jsx("div", {
            className: "column-statistic-value",
            children: formattedRowCount
          })]
        }), statisticElements]
      }), showGenerateStatistics && /*#__PURE__*/_jsx(Button, {
        kind: "ghost",
        className: "px-0",
        onClick: this.handleGenerateStatistics,
        children: "Generate Stats"
      }), error != null && /*#__PURE__*/_jsx("div", {
        className: "error-message",
        children: "".concat(error)
      }), statistics && !loading && /*#__PURE__*/_jsx(Button, {
        kind: "ghost",
        className: "px-0",
        onClick: this.handleGenerateStatistics,
        icon: dhRefresh,
        children: "Refresh"
      }), loading && /*#__PURE__*/_jsxs("div", {
        className: "column-statistics-loading",
        children: [/*#__PURE__*/_jsx(LoadingSpinner, {
          className: "loading-spinner-vertical-align"
        }), "Calculating Stats..."]
      })]
    });
  }
}
/** Automatically generate the statistics when the row count is below this threshold */
_defineProperty(ColumnStatistics, "AUTO_GENERATE_LIMIT", 100000);
export default ColumnStatistics;
//# sourceMappingURL=ColumnStatistics.js.map